import React, { useState } from "react";

export function useWindowResize() {
 const [width, setWidth] = useState<number>(window.innerWidth);

 React.useLayoutEffect(() => {
  const setDimensions = () => {
   setWidth(window.innerWidth);
  };

  window.addEventListener("resize", setDimensions);

  return () => window.removeEventListener("resize", setDimensions);
 }, []);

 return { width: width };
}
